import { render, staticRenderFns } from "./Dashboard.view.vue?vue&type=template&id=2b0eb02a&scoped=true"
import script from "./Dashboard.view.vue?vue&type=script&lang=ts"
export * from "./Dashboard.view.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.view.vue?vue&type=style&index=0&id=2b0eb02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0eb02a",
  null
  
)

export default component.exports